import React from "react";
import { Button, Modal } from "react-bootstrap";
import { HelpOutline } from "@material-ui/icons";

function FormActionPrompt({
  handleClosePrompt,
  exportFormToPDF,
  sendForm,
  clearTransactionSelection,
  transaction,
  showPrompt,
  promptType,
}) {
  return (
    <Modal
      show={showPrompt}
      onHide={() => handleClosePrompt()}
      dialogClassName="modal-90w"
      className="modal-med modal-400 modal-delete"
      centered
      backdrop={false}
      style={
        window.innerWidth > 800
          ? ""
          : { width: "380px", transform: "translateY(-120px)" }
      }
    >
      <Modal.Header />
      <Modal.Body className="pb-0 text-center">
        <HelpOutline />
        {promptType === "upload" ||
        promptType === "uploadAndOpenConsent" ||
        promptType === "uploadAndOpenIntake" ? (
          <>
            <p className="mt-2">
              You are about to upload this form to the following artwork:
            </p>
            <p style={{ fontSize: "15px" }}>
              {transaction ? transaction.description : ""}
            </p>
            <p style={{ fontSize: "15px" }}>
              {transaction ? transaction.shortName : ""}
            </p>
            <p>Are you sure you want to do this?</p>
          </>
        ) : promptType === "send" ? (
          <>
            <p>
              You are about to send this form to the{" "}
              {transaction.hasGuardian ? "Guardian" : "Client"} on this artwork:
            </p>
            <p>
              {transaction.hasGuardian
                ? transaction.guardianName
                : transaction.clientName}
            </p>
            <p>Are you sure you want to do this?</p>
          </>
        ) : promptType === "clear" ? (
          <>
            <p className="mt-2">
              Clearing the currently selected artwork will reset the form to
              blank.
            </p>
            <p>Are you sure you want to do this?</p>
          </>
        ) : (
          ""
        )}
      </Modal.Body>
      <Modal.Footer>
        {promptType === "upload" ||
        promptType === "uploadAndOpenConsent" ||
        promptType === "uploadAndOpenIntake" ? (
          <>
            <Button
              variant="primary"
              className="btn-blue w-140"
              onClick={() => exportFormToPDF(promptType)}
            >
              Yes
            </Button>
            <Button
              variant="primary"
              className="btn-blue btn-outlined w-140"
              onClick={() => handleClosePrompt()}
            >
              No
            </Button>
          </>
        ) : promptType === "send" ? (
          <>
            <Button
              variant="primary"
              className="btn-blue w-140"
              onClick={() => sendForm(transaction.id)}
            >
              Yes
            </Button>
            <Button
              variant="primary"
              className="btn-blue btn-outlined w-140"
              onClick={() => handleClosePrompt()}
            >
              No
            </Button>
          </>
        ) : promptType === "clear" ? (
          <>
            <Button
              variant="primary"
              className="btn-blue w-140"
              onClick={() => clearTransactionSelection()}
            >
              Yes
            </Button>
            <Button
              variant="primary"
              className="btn-blue btn-outlined w-140"
              onClick={() => handleClosePrompt()}
            >
              No
            </Button>
          </>
        ) : (
          ""
        )}
      </Modal.Footer>
    </Modal>
  );
}

export default FormActionPrompt;
